<template>
  <sub-page :title="title">
    <div class="job-page">
      <!-- 二次认证弹窗 -->
      <div class="verify-dialog" v-if="showVerify">
        <div class="dialog-mask"></div>
        <div class="dialog-body">
          <div class="dialog-title">该功能需要进行二次认证</div>
          <div class="dialog-actions">
            <button class="btn-later" @click="showVerify = false">稍后去认证</button>
            <button class="btn-now" @click="goVerify">现在去认证</button>
          </div>
        </div>
      </div>
    </div>
  </sub-page>
</template>

<script>
import SubPage from './SubPage.vue'

export default {
  name: 'JobHunting',
  components: { SubPage },
  data() {
    return {
      title: '求职招聘',
      showVerify: true
    }
  },
  methods: {
    goVerify() {
      this.showVerify = false
      // 跳转认证逻辑
    }
  }
}
</script>

<style scoped>
.job-page {
  background: #F3F8FB;
  min-height: 100%;
}
.verify-dialog {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 100;
}
.dialog-mask {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
}
.dialog-body {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #fff;
  border-radius: calc(16 * var(--w));
  width: calc(600 * var(--w));
  overflow: hidden;
}
.dialog-title {
  padding: calc(40 * var(--w)) calc(32 * var(--w));
  font-size: calc(32 * var(--w));
  color: #323233;
  text-align: center;
}
.dialog-actions {
  display: flex;
  border-top: 1px solid #f0f0f0;
}
.btn-later, .btn-now {
  flex: 1;
  height: calc(88 * var(--w));
  border: none;
  font-size: calc(32 * var(--w));
  cursor: pointer;
}
.btn-later {
  background: #fff;
  color: #ff976a;
  border-right: 1px solid #f0f0f0;
}
.btn-now {
  background: #fff;
  color: #2E8CF6;
}
</style>



// WEBPACK FOOTER //
// src/pages/JobHunting.vue